
import React from 'react';
import { RefreshCw } from "lucide-react";
import { HierarchicalAgentTree } from './hierarchy/HierarchicalAgentTree';

const AgentHierarchyMap = () => {
  return (
    <div className="p-6 bg-gradient-to-br from-background to-muted/20 min-h-full">
      <HierarchicalAgentTree />
    </div>
  );
};

export default AgentHierarchyMap;
